export function getIsCurrentTrial(state, trialId) {
  const {
    activeTrials
  } = state;
  const isCurrentTrial = activeTrials.some(activeTrial => {
    return activeTrial.trials[0].id === trialId;
  });
  return isCurrentTrial;
}